/**
 * Override globale del legame "voce di menù → modulo che la sblocca + ruoli che la vedono".
 * Vale per tutte le organizzazioni. Riga assente = default dichiarato in _helpers/menu-voci.ts.
 */
export class MenuVoceBinding {
  id: number;
  /** Id della voce nel dizionario (es. 'ordini-inviati'). */
  voceId: string;
  /** Codice modulo (es. 'PRO-BASE-UI'). Null/vuoto = nessun requisito di licenza. */
  moduloCodice?: string | null;
  /** Ruoli in OR separati da virgola (es. 'MANAGER, OPER'). Null/vuoto = nessun requisito di ruolo. */
  ruoli?: string | null;
  /** False = voce spenta ovunque. */
  isActive: boolean;
}

/** Separatore usato nella colonna `ruoli`. */
export const RUOLI_SEPARATOR = ',';

export function ruoliFromCsv(csv?: string | null): string[] {
  return (csv ?? '')
    .split(RUOLI_SEPARATOR)
    .map(r => r.trim())
    .filter(r => r.length > 0);
}

export function ruoliToCsv(ruoli: readonly string[]): string | null {
  const puliti = ruoli.map(r => r.trim()).filter(r => r.length > 0);
  return puliti.length > 0 ? puliti.join(RUOLI_SEPARATOR) : null;
}
